/**
 * CSV serialisation for the user export.
 *
 * Extracted from UsersPage, where it lived as closures inside the component
 * body and so could not be tested. This path writes real customer PII (name +
 * email) to a file a human then opens in a spreadsheet, which is exactly the
 * kind of code that should not have been the app's only untested surface.
 */

export interface ExportedUserRow {
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
}

/** RFC 4180: a field containing a quote, comma or newline is quoted, and inner quotes are doubled. */
export function escapeCsvCell(value: string): string {
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/**
 * RFC 4180 uses CRLF between records and a trailing CRLF after the last one.
 * Excel is the consumer here and is strict about both.
 */
export function buildUsersCsv(rows: readonly ExportedUserRow[]): string {
  const header = ['First Name', 'Last Name', 'Email'].join(',');
  const body = rows
    .map((r) => [r.firstName, r.lastName, r.email].map(escapeCsvCell).join(','))
    .join('\r\n');
  return `${header}\r\n${body}\r\n`;
}
